<div id="seccion-mascotas"></div>
<!--NUEVA MASCOTA-->
<!--<div *ngIf="newmascota">
  <app-mascota-edit [mascota]="mascota"></app-mascota-edit>
  <input
    type="file"
    #fileInputMascotaPrincipal
    accept="image/*"
    style="display: none"
    (change)="onFileSelectedPrincipal($event)"
  />
</div>-->

<!--MASCOTAS-->
<section id="newmascota" class="iguau-pets" *ngIf="perfil.rol_social">
  <div class="iguau-pets-heading row align-items-center g-3 mt-3 mb-3">
    <div class="col">
      <div class="iguau-pets-heading-content">
        <i class="fa-solid fa-paw iguau-pets-heading-icon" aria-hidden="true"></i>
        <div class="iguau-pets-heading-copy">
          <h2>Mascotas <span class="iguau-pets-count" *ngIf="mascotas?.length">{{ mascotas.length }}</span></h2>
          <p class="iguau-pets-intro mb-0">Conoce a los compañeros de cuatro patas que hacen especial este perfil.</p>
        </div>
      </div>
    </div>
    <div class="col-12 col-lg-auto" *ngIf="mascotas && (mascotas | keyvalue)?.length">
      <div class="pet-filters iguau-pets-filters" aria-label="Filtrar mascotas">
        <button class="filter-button" (click)="seleccionarMascota(null)"
          *ngIf="mascotas.length > 1"
          [ngClass]="{'is-active': mascotaSeleccionada == null}"
          type="button" data-filter="all">Todas</button>
        <button class="filter-button" (click)="seleccionarMascota(mascota)"
          [ngClass]="{'is-active': mascotaSeleccionada == mascota}"
          type="button" data-filter="all" *ngFor="let mascota of maximoMascotasAlcanzado(4)">{{ mascota.ma_nombre | firstWord}}</button>
        <button *ngIf="misdatos.ID == perfil.ID" type="button" class="filter-button btn-primary" (click)="nuevaMascota()"><i class="fa-solid fa-paw"></i> Nueva mascota</button>
      </div>    
    </div>
  </div>
  <div class="row g-3 mt-2 align-items-stretch">
    <div class="col-12 mb-3" *ngFor="let mascota of obtenerMascotas(); let i = index">
      <app-mascota-show [mascota]="mascota" [ancho]="12" *ngIf="mascota.ma_novisible == '' || misdatos.ID == perfil.ID"></app-mascota-show>
    </div>
    <!--<div class="col-xs-12 g-3"
        *ngFor="let mascota of mascotas; let i = index"
        [ngClass]="{
          'col-12': columnas % 2 !== 0 && i === columnas - 1,
          'col-lg-4': !(columnas % 2 !== 0 && i === columnas - 1)
        }">
      <app-mascota-show [mascota]="mascota" [ancho]="(columnas % 2 !== 0 && i === columnas - 1) ? '2' : '4'"></app-mascota-show>
    </div>-->
  </div>  
  <div class="row align-items-stretch" *ngIf="misdatos.ID == perfil.ID && mascotas?.length == 0">
    <div class="col-12 d-flex">
      <div class="iguau-pets-empty bg-white rounded-4 mb-5 p-4 position-relative text-center">
        <div class="iguau-pets-empty-icon"><i class="fa-solid fa-paw" aria-hidden="true"></i></div><div class="fw-bold text-iguau fs-4">¡Presenta a tu mascota!</div>
        <div class="mt-2">
          Comparte con la comunidad a tu inseparable mascota. Añádela y crea su perfil para que todos puedan conocerla.
        </div>
        <div class="w-100 mt-3">
          <button type="button" class="btn btn-primary" (click)="nuevaMascota()"><i class="fa-solid fa-paw"></i> Nueva mascota</button>
        </div>
    </div>
  </div>
  </div>
  <div class="iguau-pets-empty" *ngIf="misdatos.ID != perfil.ID && mascotas?.length === 0"><i class="fa-regular fa-heart" aria-hidden="true"></i><p class="mb-0">Todavía no hay mascotas visibles en este perfil.</p></div>
  <!--NUEVA MASCOTA-->
  <!--<div *ngIf="misdatos.ID == perfil.ID && !newmascota && (misdatos | keyvalue)?.length">
    <div class="iguau-pets-empty bg-white rounded-4 mb-5 p-4 position-relative text-center">
      <div *ngIf="mascotas.length == 0" class="fw-bold text-iguau fs-4">Añade tu mascota</div>
      <div *ngIf="mascotas.length > 0" class="fw-bold text-iguau fs-4">¿Tienes otra mascota?</div>
      <div class="mt-2">
        Comparte con la comunidad a tu inseparable mascota. Añádela y crea su perfil para que todos puedan conocerla.
      </div>
      <div class="w-100 mt-3">
        <button type="button" class="btn btn-primary" (click)="nuevaMascota()">Nueva mascota</button>
      </div>
    </div>
  </div>-->
</section>
